import { isBefore, max } from 'date-fns';
import type { ComponentProps } from 'react';
import { type DatePickerDateType, DateTimeInput, getDatePickerDateType, getDateType } from 'ui';

type InputP = ComponentProps<typeof DateTimeInput>['input'];

type ItemP = {
  label?: ComponentProps<typeof DateTimeInput>['item']['label'];
  name: ComponentProps<typeof DateTimeInput>['item']['name'];
  rules: ComponentProps<typeof DateTimeInput>['item']['rules'];
};

type P = {
  input?: InputP;
  item: ItemP;
};

const EventPublish = ({ input, item }: P) => {
  const now = new Date();
  const minimum = input?.minimum ? max([now, input.minimum]) : now;

  return (
    <DateTimeInput
      input={{
        showTime: true,
        ...input,
        minimum,
      }}
      item={{
        getValueFromEvent(event: DatePickerDateType): DatePickerDateType {
          if (isBefore(getDateType(event), minimum)) {
            return getDatePickerDateType(minimum);
          }

          return event;
        },
        ...item,
      }}
    />
  );
};

export default EventPublish;
